<template>
  <div class="STERiJECT">
    <!-- ① 第一張 -->
    <section class="bleed-row first-row">
      <picture>
        <source media="(max-width: 899px)" :srcset="phonePath(sections[0].img)" />
        <img
          :src="webPath(sections[0].img)"
          :alt="t(sections[0].key + '.title')"
          class="row-img"
          loading="lazy"
        />
      </picture>

      <div
        class="overlay overlay-left"
        :class="['mpos-' + sections[0].mobile, 'center-title']"
      >
        <h3 class="ov-title" v-html="t(sections[0].key + '.title')"></h3>
        <p class="ov-body" v-html="t(sections[0].key + '.body')"></p>
        <p class="ov-body-small" v-html="t(sections[0].key + '.body1')"></p>
      </div>
    </section>


    <!-- ② interstitial-bleed -->
    <section class="interstitial-bleed second-row">
      <div class="interstitial-inner">
        <h3 class="inter-title" v-html="t('STERiJECT.mid.title')"></h3>
        <p class="inter-body" v-html="t('STERiJECT.mid.body')"></p>
      </div>
    </section>

    <!-- ③.5 s2-2：三張圖片＋文字（新加的區塊） -->
    <section class="s2-2-board">
      <div class="s2-2-inner">
        <article
          v-for="(item, idx) in s22Items"
          :key="'s2-2-' + idx"
          class="s2-2-card"
        >
          <img
            :src="rootPath(item.img)"
            :alt="t(item.title)"
            class="s2-2-img"
            loading="lazy"
          />
          <h4 class="s2-2-title" v-html="t(item.title)"></h4>
          <p class="s2-2-body" v-html="t(item.body)"></p>
        </article>
      </div>
    </section>


    <!-- ③ s2-board -->
    <section class="s2-board s2-row">
      <picture>
        <source media="(max-width: 899px)" :srcset="phonePath('STERiJECT_s2.png')" />
        <img
          :src="webPath('STERiJECT_s2.png')"
          :alt="t('STERiJECT.title')"
          class="row-img"
          loading="lazy"
        />
      </picture>

      <div class="s2-title">
        <h3 v-html="t('STERiJECT.mid.title2')"></h3>
      </div>

      <div class="s2-overlay">
        <div class="s2-row-top">
          <div v-for="(c, idx) in circles.slice(0,3)" :key="'s2t-' + c.id" class="s2-circle">
            <img :src="circlePath(c.id)" :alt="'feature-'+c.id" class="circle-img" />
            <span class="circle-text" v-html="t(`STERiJECT.mid.s${idx+1}`)"></span>
          </div>
        </div>

        <div class="s2-row-bottom">
          <div v-for="(c, idx) in circles.slice(3,5)" :key="'s2b-' + c.id" class="s2-circle">
            <img :src="circlePath(c.id)" :alt="'feature-'+c.id" class="circle-img" />
            <span class="circle-text" v-html="t(`STERiJECT.mid.s${idx+4}`)"></span>
          </div>
        </div>
      </div>
    </section>

    <!-- ④ s3-board -->
    <section class="s3-board">
      <div class="s3-inner">
        <div class="s3-tabs">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            :class="['s3-tab', { active: activeTab === tab.key }]"
            @click="activeTab = tab.key"
            v-html="t(tab.label)"
          ></button>
        </div>

        <div class="s3-content">
          <div v-for="tab in tabs" :key="'content-' + tab.key" v-show="activeTab === tab.key">
            <div v-for="(item, idx) in tab.items" :key="'item-' + tab.key + '-' + idx" class="s3-item">
              <div class="s3-item-title" v-html="t(item.title)"></div>
              <div class="s3-item-body"  v-html="t(item.body)"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⑤ 第二張（原來迴圈的 i=1） -->
    <section class="bleed-row flip second-image-row">
      <picture>
        <source media="(max-width: 899px)" :srcset="phonePath(sections[1].img)" />
        <img
          :src="webPath(sections[1].img)"
          :alt="t(sections[1].key + '.title')"
          class="row-img"
          loading="lazy"
        />
      </picture>

      <div
        class="overlay overlay-right"
        :class="['mpos-' + sections[1].mobile, 'left-title']"
      >
        <h3 class="ov-title" v-html="t(sections[1].key + '.title')"></h3>
        <p class="ov-body" v-html="t(sections[1].key + '.body')"></p>
      </div>
    </section>


    <!-- ⑥ 第三張：桌機顯示圖片；手機改成 interstitial-bleed 風格、置中文字 -->
    <section class="bleed-row third-row third-image-row">
      <picture class="third-desktop-picture">
        <source media="(max-width: 899px)" :srcset="phonePath(sections[2].img)" />
        <img
          :src="webPath(sections[2].img)"
          :alt="t(sections[2].key + '.title')"
          class="row-img"
          loading="lazy"
        />
      </picture>

      <div
        class="overlay overlay-left third-desktop-overlay"
        :class="['mpos-' + sections[2].mobile, 'left-title', 'last-overlay']"
      >
        <h3 class="ov-title" v-html="t(sections[2].key + '.title')"></h3>
        <p class="ov-body" v-html="t(sections[2].key + '.body')"></p>
      </div>

      <div class="third-mobile interstitial-bleed">
        <div class="interstitial-inner">
          <h3 class="inter-title" v-html="t(sections[2].key + '.title')"></h3>
          <p class="inter-body" v-html="t(sections[2].key + '.body')"></p>
        </div>
      </div>
    </section>

    <!-- ⑦ 針長度選擇區（新段） -->
    <section class="len-guide">
      <!-- 大標題覆蓋在最上面 -->
      <h3 class="len-title" v-html="t('STERiJECT.len.title')"></h3>

      <!-- 三塊說明 -->
      <div class="len-inner">
        <article class="len-card">
          <div class="len-chip"><span>{{ t('STERiJECT.len.short.chip') }}</span></div>
          <h4 class="len-h4" v-html="t('STERiJECT.len.short.title')"></h4>
          <ul class="len-list">
            <li v-for="(it, i) in lengthBlocks.short" :key="'s-'+i">{{ t(it) }}</li>
          </ul>
        </article>

        <article class="len-card">
          <div class="len-chip"><span>{{ t('STERiJECT.len.mid.chip') }}</span></div>
          <h4 class="len-h4" v-html="t('STERiJECT.len.mid.title')"></h4>
          <ul class="len-list">
            <li v-for="(it, i) in lengthBlocks.mid" :key="'m-'+i">{{ t(it) }}</li>
          </ul>
        </article>

        <article class="len-card">
          <div class="len-chip"><span>{{ t('STERiJECT.len.long.chip') }}</span></div>
          <h4 class="len-h4" v-html="t('STERiJECT.len.long.title')"></h4>
          <a href="/app/product/STERiGLIDE" class="len-link">{{ t('STERiJECT.len.cannula') }}</a>
          <ul class="len-list">
            <li v-for="(it, i) in lengthBlocks.long" :key="'l-'+i">{{ t(it) }}</li>
          </ul>
        </article>
      </div>
    </section>

    <!-- ⑧ STERiJECT_05 背景＋左圖右文（新段） -->
    <section class="s5-hero bleed-row">
      <picture>
        <source media="(max-width: 899px)" :srcset="phonePath('STERiJECT_05.png')" />
        <img
          :src="webPath('STERiJECT_05.png')"
          alt=""
          class="row-img"
          loading="lazy"
        />
      </picture>

      <!-- 以版心為中心：徽章往左、文字往右固定距離 -->
      <div class="s5-overlay">
        <img
          :src="rootPath('STERiJECT_05_1.png')"
          alt="badge"
          class="s5-badge"
          loading="lazy"
        />
        <div class="s5-copy">
          <h3 class="s5-title" v-html="t('STERiJECT.s5.title')"></h3>
          <p class="s5-body"  v-html="t('STERiJECT.s5.body')"></p>
        </div>
      </div>
    </section>


    <!-- 規格表（原樣） -->
    <div class="table-bleed">
      <div class="table-inner">
        <div class="table-head">
          <span class="text-primary fw-bold"><p v-html="$t('model')"></p></span>
          <span class="thin-wall">{{ $t('STERiJECT.Thin-wall') }}</span>
        </div>

        <div class="table-scroller">
          <table class="table custom-table">
            <thead>
              <tr class="header-row">
                <th scope="col">Gauge</th>
                <th scope="col">Code</th>
                <th scope="col">Description</th>
                <th scope="col">Inch</th>
                <th scope="col">*TSKiD™</th>
                <th scope="col">Box</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, groupIndex) in groupedData" :key="groupIndex">
                <tr
                  v-for="(item, itemIndex) in group.items"
                  :key="item.code"
                  :class="getRowClass(displayIndex(groupIndex, itemIndex))"
                >
                  <td v-if="itemIndex === 0" :rowspan="group.items.length" class="gauge-cell">
                    {{ group.gauge }}
                  </td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.inch }}</td>
                  <td>{{ item.utw }}</td>
                  <td>{{ item.box }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <p class="table-note">
      TSK 尖針適合結構清晰、點狀設計的注射規劃，若需進行大面積鋪層或深層注射<br>
      建議搭配使用 TSK STERiGLIDE™鈍針
      <a href="/app/product/STERiGLIDE" class="len-link">{{ t('STERiJECT.len.cannula') }}</a>
      ，實現層次與點位互補的治療效果
    </p>
  </div>
</template>

<script>
export default {
  name: 'STERiJECTPage',
  data() {
    return {
      // 仍保留 sections，供文案/路徑引用（這頁只用到 0,1,2）
      sections: [
        { img: 'STERiJECT_01.png', key: 'STERiJECT.s1', mobile: 'top'     },
        { img: 'STERiJECT_02.png', key: 'STERiJECT.s2', mobile: 'bottom'  },
        { img: 'STERiJECT_04.png', key: 'STERiJECT.s3', mobile: 'top'     }
      ],
      circles: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }],
      s22Items: [
        {
          img: 'STERiJECT_00_1.png',
          title: 'STERiJECT.s2-2.title1',
          body:  'STERiJECT.s2-2.body1',
        },
        {
          img: 'STERiJECT_00_2.png',
          title: 'STERiJECT.s2-2.title2',
          body:  'STERiJECT.s2-2.body2',
        },
        {
          img: 'STERiJECT_00_3.png',
          title: 'STERiJECT.s2-2.title3',
          body:  'STERiJECT.s2-2.body3',
        },
      ],
      tableData: [
        { gauge: '33G', code: 'PRE-33004',  description: 'Regular Hub 33G x 4mm',         inch: '³⁄₁₆″', utw: '',  box: '100' },
        { gauge: '33G', code: 'PRE-33013',  description: 'Regular Hub 33G x 13mm',        inch: '½″',   utw: '',  box: '100' },
        { gauge: '32G', code: 'PRE-32004',  description: 'Regular Hub 32G x 4mm',         inch: '³⁄₁₆″', utw: '',  box: '100' },
        { gauge: '32G', code: 'PRE-32009',  description: 'Regular Hub 32G x 9mm',         inch: '⅜″',  utw: '',  box: '100' },
        { gauge: '32G', code: 'PRE-32013',  description: 'Regular Hub 32G x 13mm',        inch: '½″',   utw: '',  box: '100' },
        { gauge: '31G', code: 'HPC-31013E', description: 'Advanced Hub 31G x 13mm',       inch: '½″',   utw: '√', box: '100' },
        { gauge: '30G', code: 'PRE-30004I', description: 'Regular Hub 30G x 4mm',         inch: '³⁄₁₆″', utw: '√', box: '100' },
        { gauge: '30G', code: 'LDS-30009I', description: 'Low Dead Space Hub 30G x 9mm',  inch: '⅜”',  utw: '√', box: '100' },
        { gauge: '30G', code: 'HPC-30013I', description: 'Advanced Hub 30G x 13mm',       inch: '½”',   utw: '√', box: '100' },
        { gauge: '27G', code: 'HPC-27013I', description: 'Advanced Hub 27G x 13mm',       inch: '½”',   utw: '√', box: '100' },
        { gauge: '27G', code: 'HPC-27019I', description: 'Advanced Hub 27G x 19mm',       inch: '¾”',   utw: '√', box: '100' }
      ],
      activeTab: 'dermatology',
      tabs: [
        {
          key: 'dermatology',
          label: 'STERiJECT.tabs.dermatology.label',
          items: [
            { title: 'STERiJECT.tabs.dermatology.s1_title', body: 'STERiJECT.tabs.dermatology.s1_body' },
            { title: 'STERiJECT.tabs.dermatology.s2_title', body: 'STERiJECT.tabs.dermatology.s2_body' },
            { title: 'STERiJECT.tabs.dermatology.s3_title', body: 'STERiJECT.tabs.dermatology.s3_body' },
            { title: 'STERiJECT.tabs.dermatology.s4_title', body: 'STERiJECT.tabs.dermatology.s4_body' },
            { title: 'STERiJECT.tabs.dermatology.s5_title', body: 'STERiJECT.tabs.dermatology.s5_body' },
          ]
        },
        {
          key: 'dental',
          label: 'STERiJECT.tabs.dental.label',
          items: [
            { title: 'STERiJECT.tabs.dental.s1_title', body: 'STERiJECT.tabs.dental.s1_body' },
            { title: 'STERiJECT.tabs.dental.s2_title', body: 'STERiJECT.tabs.dental.s2_body' },
          ]
        },
        {
          key: 'ortho',
          label: 'STERiJECT.tabs.ortho.label',
          items: [
            { title: 'STERiJECT.tabs.ortho.s1_title', body: 'STERiJECT.tabs.ortho.s1_body' },
            { title: 'STERiJECT.tabs.ortho.s2_title', body: 'STERiJECT.tabs.ortho.s2_body' }
          ]
        },
        {
          key: 'ophthalmology',
          label: 'STERiJECT.tabs.ophthalmology.label',
          items: [
            { title: 'STERiJECT.tabs.ophthalmology.s1_title', body: 'STERiJECT.tabs.ophthalmology.s1_body' },
            { title: 'STERiJECT.tabs.ophthalmology.s2_title', body: 'STERiJECT.tabs.ophthalmology.s2_body' }
          ]
        },
        {
          key: 'regenerative',
          label: 'STERiJECT.tabs.regenerative.label',
          items: [
            { title: 'STERiJECT.tabs.regenerative.s1_title', body: 'STERiJECT.tabs.regenerative.s1_body' },
            { title: 'STERiJECT.tabs.regenerative.s2_title', body: 'STERiJECT.tabs.regenerative.s2_body' },
            { title: 'STERiJECT.tabs.regenerative.s3_title', body: 'STERiJECT.tabs.regenerative.s3_body' }
          ]
        }
      ],
      lengthBlocks: {
        short: ['STERiJECT.len.short.body1', 'STERiJECT.len.short.body2'],
        mid:   ['STERiJECT.len.mid.body1', 'STERiJECT.len.mid.body2', 'STERiJECT.len.mid.body3'],
        long:  ['STERiJECT.len.long.body1', 'STERiJECT.len.long.body2']
      },
    }
  },
  computed: {
    groupedData() {
      const groups = this.tableData.reduce((acc, item) => {
        const g = acc.find(group => group.gauge === item.gauge)
        if (g) g.items.push(item)
        else acc.push({ gauge: item.gauge, items: [item] })
        return acc
      }, [])
      return groups
    }
  },
  methods: {
    t(key) { return this.$t ? this.$t(key) : key },
    webPath(file) {
      return require(`@/assets/images/AppShell/products/STERiJECT/web/${file}`)
    },
    phonePath(file) {
      return require(`@/assets/images/AppShell/products/STERiJECT/phone/${file}`)
    },
    rootPath(file) {
      return require(`@/assets/images/AppShell/products/STERiJECT/${file}`)
    },
    circlePath(n) {
      return require(`@/assets/images/AppShell/products/STERiJECT/STERiJECT_02_${n}.png`)
    },
    displayIndex(groupIndex, itemIndex) {
      let index = 0
      for (let i = 0; i < groupIndex; i++) index += this.groupedData[i].items.length
      return index + itemIndex
    },
    getRowClass(index) {
      return index % 2 === 0 ? 'odd-row' : 'even-row'
    }
  }
}
</script>

<style scoped>
/* ---------------------------------------
 * 基礎：容器與出血圖
 * ------------------------------------- */
.STERiJECT { overflow-x: hidden; }

.bleed-row {
  --content-pad: 24px;
  position: relative;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  line-height: 0;
}
@media (max-width: 899px) { .bleed-row { --content-pad: 16px; } }

.row-img { display: block; width: 100%; height: auto; margin: 0; padding: 0; }

/* ---------------------------------------
 * 共用：Overlay（文字浮層）
 * ------------------------------------- */
.overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 42ch;
  padding: 0;
  background: none;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}
.overlay-left  { left: 15%; }
.overlay-right { right: 15%; }
.last-overlay  { top: 30%; transform: translateY(-50%); }

.ov-title { margin: 0 0 6px; font-weight: 700; color: #0b69b7; }
/* 先做一個『內文基準字級』變數，所有 overlay 內文都吃它 */
.overlay {
  --ov-body-size: 1rem;     /* 預設值；會被各段落的規則覆蓋 */
}

/* 內文用變數；小字就照比例縮（你要 0.6rem ≈ 0.75 × 0.8rem，就抓 0.75 ~ 0.8 之類的係數） */
.ov-body        { font-size: var(--ov-body-size); line-height: 1.6; }
.ov-body-small  { 
  margin-top: 12px;         /* 你要「上面留一點距離」 */
  font-size: calc(var(--ov-body-size) * 0.75);  /* ← 跟著一起縮放 */
  line-height: 1.6;
}

/* === 第一張：把原本寫死在 .ov-body 的 clamp 改成只『設定變數』 === */
.first-row { container-type: inline-size; }

@supports (font-size: 1cqw) {
  .first-row .overlay {
    /* 原本：.first-row .ov-body { font-size: clamp(14px, 2.4cqw, 20px); } */
    --ov-body-size: clamp(14px, 2.4cqw, 20px);
  }
}
@supports not (font-size: 1cqw) {
  .first-row .overlay {
    /* 原本：.first-row .ov-body { font-size: clamp(14px, 1.4vw, 20px); } */
    --ov-body-size: clamp(14px, 1.4vw, 20px);
  }
}

/* 行寬限制、排版不變：繼續放在 ov-body 上即可 */
.first-row .ov-body,
.first-row .ov-body-small {
  max-width: 45ch;
  margin-inline: auto;
  text-wrap: balance;
}
@media (max-width: 899px) {
  .first-row .ov-body,
  .first-row .ov-body-small { max-width: 38ch; }
}


/* 手機 overlay 擺位 */
@media (max-width: 899px) {
  .overlay {
    left: 50% !important; width: calc(100% - 24px);
    max-width: 660px; text-align: center !important;
    transform: translate(-50%, -50%);
  }
  .mpos-top { top: 30%; } .mpos-middle { top: 50%; } .mpos-bottom { top: 70%; }
}
.center-title { text-align: center; }
.left-title   { text-align: left; }

/* ---------------------------------------
 * 第一張：讓內文跟圖寬度縮放（僅內文）
 * ------------------------------------- */
.first-row { container-type: inline-size; }

@supports (font-size: 1cqw) {
  .first-row .ov-body  {
    font-size: clamp(14px, 2.4cqw, 20px);
    line-height: 1.6;
    max-width: 45ch;
    margin-inline: auto;
    text-wrap: balance;
    --ov-body-size: clamp(14px, 2.4cqw, 20px);
  }
}
@supports not (font-size: 1cqw) {
  .first-row .ov-body {
    font-size: clamp(14px, 1.4vw, 20px);
    line-height: 1.6;
    max-width: 45ch;
    margin-inline: auto;
    text-wrap: balance;
    --ov-body-size: clamp(14px, 1.4vw, 20px);
  }
}
/* 行寬限制、排版不變：繼續放在 ov-body 上即可 */
.first-row .ov-body,
.first-row .ov-body-small {
  max-width: 45ch;
  margin-inline: auto;
  text-wrap: balance;
}
@media (max-width: 899px) {
  .first-row .ov-body,
  .first-row .ov-body-small { max-width: 38ch; }
}
/* ---------------------------------------
 * 中繼灰底：interstitial-bleed（第二段 & 第三張手機）
 * ------------------------------------- */
.interstitial-bleed {
  --content-pad: 24px;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  background: #f6f6f6;
  aspect-ratio: 1920 / 367;
  display: flex; align-items: center; justify-content: center;
}
@media (max-width: 899px) {
  .interstitial-bleed { --content-pad: 16px; aspect-ratio: 1080 / 1067; }
}

.interstitial-inner { width: 60%; max-width: 1100px; margin: 0 auto; text-align: center; line-height: 1.6; }
@media (max-width: 899px) { .interstitial-inner { width: 100%; padding: 0 16px; } }

.inter-title { margin: 0 0 10px; font-weight: 800; color: #306fb4; }
.inter-body  { margin: 0 auto; color: #000; font-size: 1rem; max-width: 70ch; }

/* 讓第二段內文跟容器縮放（僅內文） */
.second-row .interstitial-inner { container-type: inline-size; }
@supports (font-size: 1cqw) {
  .second-row .inter-body {
    font-size: clamp(14px, 2.4cqw, 20px);
    line-height: 1.7;
    max-width: 70ch;
    margin-inline: auto;
    text-wrap: balance;
  }
}
@supports not (font-size: 1cqw) {
  .second-row .inter-body {
    font-size: clamp(14px, 1.6vw, 20px);
    line-height: 1.7;
    max-width: 70ch;
    margin-inline: auto;
    text-wrap: balance;
  }
}
@media (max-width: 899px) { .second-row .inter-body { max-width: 42ch; } }

/* ---------------------------------------
 * s2-board
 * ------------------------------------- */
.s2-board {
  --content-pad: 24px;
  position: relative;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  line-height: 0;
}
@media (max-width: 899px) { .s2-board { --content-pad: 16px; } }

.s2-title {
  position: absolute; top: 5%; left: 50%;
  transform: translateX(-50%);
  text-align: center; width: 100%; pointer-events: none;
}
.s2-title h3 { margin: 0; font-weight: 800; color: #306fb4; }

.s2-overlay {
  position: absolute; top: 50%; right: 0; width: 66.6667%;
  transform: translateY(-50%) translateX(-10%);
  display: flex; justify-content: space-between; align-items: center;
  gap: clamp(8px, 1.5vw, 16px);
}
.s2-row-top, .s2-row-bottom { display: contents; }

.s2-circle {
  position: relative; flex: 1 1 0; max-width: 12rem;
  aspect-ratio: 1/1; border-radius: 50%; overflow: hidden;
  display: grid; place-items: center;
}
.circle-img { width: 100%; height: 100%; object-fit: cover; }
.circle-text {
  position: absolute; inset: 0; display: grid; place-items: center;
  text-align: center; padding: 0.5rem; line-height: 1.3;
  font-weight: 700; font-size: clamp(12px, 1.1vw, 16px); color: #306fb4;
}

@media (max-width: 899px) {
  .s2-overlay {
    top: 0; left: 50%; transform: translateX(-50%) translateY(20%);
    width: 100%; flex-direction: column; align-items: center; gap: 12px; padding: 12px 0;
  }
  .s2-row-top, .s2-row-bottom { display: flex; justify-content: center; gap: 12px; }
  .s2-circle { width: clamp(7rem, 28vw, 10rem); }
}

/* ---------------------------------------
 * s2-2：三張圖＋文（介於 s2 與 s3）
 * 高度風格比照 s3-board：full-bleed + 上下 padding
 * ------------------------------------- */
.s2-2-board {
  --content-pad: 24px;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  background: #fff;
  padding-block: 40px; /* 與 s3-board 一樣的高度感 */
}
@media (max-width: 899px) {
  .s2-2-board {
    --content-pad: 16px;
    padding-block: 24px;
  }
}

.s2-2-inner {
  width: 60%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  gap: 24px;
  justify-content: space-between;
}
@media (max-width: 899px) {
  .s2-2-inner {
    width: 100%;
    padding: 0 16px;
    flex-direction: column;       /* 手機：改成往下堆疊 */
    align-items: center;
  }
}

.s2-2-card {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.s2-2-img {
  width: 100%;
  max-width: 320px;
  height: auto;
  display: block;
}

/* 標題：藍色 */
.s2-2-title {
  margin: 12px 0 6px;
  font-weight: 700;
  color: #306fb4; /* 跟其他 STERiJECT 藍一致 */
}

/* 內文：灰色 */
.s2-2-body {
  margin: 0;
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
  max-width: 38ch;
}


/* ---------------------------------------
 * s3 Tabs（方案 A）
 * ------------------------------------- */
.s3-board {
  --content-pad: 24px;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
  aspect-ratio: auto !important;   /* 取消固定高 */
  background: #fff;
  display: block !important;       /* 不用 align-items: center */
  padding-block: 40px !important;
}
@media (max-width: 899px) { .s3-board { --content-pad: 16px; padding-block: 24px !important; } }

/* 共用版心：tabs 與 content 同寬 */
.s3-inner {
  width: 60%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative; /* sticky 參考 */
}

/* 手機左右留白加大 */
@media (max-width: 899px){
  .s3-inner { padding-left: 24px !important; padding-right: 24px !important; }
}

/* Tabs */
.s3-tabs {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px 28px;
  padding: 0;
  position: sticky; top: 0; z-index: 2;
  background: #fff;
  padding-block: 8px;
  margin-top: 24px;
  margin-bottom: 16px;
  border-bottom: none;
}

/* Tab 按鈕 */
.s3-tab {
  --grad-a: #469cd6; --grad-b: #d1dc62;
  padding: 12px 32px;
  font-weight: 600;
  border-radius: 8px;
  border: 2px solid transparent;
  color: #306fb4;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  background:
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90deg, var(--grad-a), var(--grad-b)) border-box;
  background-clip: padding-box, border-box;
  appearance: none;
}
.s3-tab.active {
  background: linear-gradient(90deg, var(--grad-a), var(--grad-b)) padding-box;
  color: #fff;
  border: 2px solid transparent;
  border-radius: 8px;
}

/* 內容區 */
.s3-content {
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  padding: 0 0 32px;   /* 底部留白 */
  contain: layout paint;
}
.s3-content > div {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
@media (max-width: 899px) {
  .s3-content > div { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
.s3-item-title { font-weight: 700; margin-bottom: 4px; color: #000; text-align: left; }
.s3-item-body  { color: #000; line-height: 1.6; text-align: left; }

/* ---------------------------------------
 * 第二張（右側文字）
 * ------------------------------------- */
.second-image-row { container-type: inline-size; }
.second-image-row .overlay.overlay-right {
  right: 0; left: 55%;
  width: 40%; max-width: none; text-align: left; padding-right: 5%;
}
@media (max-width: 899px) {
  .second-image-row .overlay.overlay-right {
    left: 50%; width: 55%;
    transform: translateX(-50%) translateY(-50%);
    text-align: left; padding: 0;
  }
  .second-image-row .overlay.overlay-right .ov-title {
    display: block; text-align: center;
    font-size: clamp(16px, 4vw, 24px); margin: 0 auto 0.5em; overflow: hidden;
  }
  .second-image-row .overlay.overlay-right .ov-body {
    display: block; width: 70%; margin: 0 auto;
    text-align: left; font-size: clamp(14px, 3.5vw, 18px); line-height: 1.5;
  }
}

/* ---------------------------------------
 * 第三張（桌機 overlay & 手機 interstitial）
 * ------------------------------------- */
.third-image-row { container-type: inline-size; }
.third-mobile { display: none; }
.third-desktop-picture, .third-desktop-overlay { display: block; }

@media (max-width: 899px) {
  .third-desktop-picture, .third-desktop-overlay { display: none; }
  .third-mobile { display: flex; }
}

/* 桌機 overlay 垂直置中 */
.third-image-row .third-desktop-overlay { top: 50% !important; transform: translateY(-50%); }

/* 手機 interstitial 文字（僅內文） */
@supports (font-size: 1cqw) {
  .third-image-row .third-mobile .inter-body {
    font-size: clamp(14px, 2.4cqw, 18px);
    line-height: 1.6; max-width: 40ch; text-align: left;
  }
}
@supports not (font-size: 1cqw) {
  .third-image-row .third-mobile .inter-body {
    font-size: clamp(14px, 1.6vw, 20px);
    text-align: left;
  }
}

/* ---------------------------------------
 * 表格
 * ------------------------------------- */
.table-bleed {
  --content-pad: 24px;
  background: #f0f0f0;
  margin-top: 40px; padding: 40px 0;
  width: calc(100% + (var(--content-pad) * 2));
  margin-left: calc(var(--content-pad) * -1);
  margin-right: calc(var(--content-pad) * -1);
}
@media (max-width: 899px) {
  .table-bleed { --content-pad: 16px; padding: 24px 0; margin-top: 24px; }
}
.table-inner { width: 60%; max-width: 1100px; margin: 0 auto; }
@media (max-width: 899px) { .table-inner { width: 100%; padding: 0 16px; } }

.table-head { display: flex; justify-content: space-between; margin-bottom: 10px; }
.table-head .thin-wall { font-style: italic; color: #000; }

.table { width: 100%; border-collapse: separate; border-spacing: 0 5px; }
.table th, .table td { padding: 0.75rem; vertical-align: middle; }
.table thead th { background-color: #50A7DF; color: #fff; border-bottom: 2px solid #dee2e6; }
.table tbody tr { border-top: 5px solid #fff; }
.table tbody td { border-top: 1px solid #dee2e6; border-right: 1px solid #dee2e6; }
.table tbody td:last-child { border-right: none; }
.custom-table .gauge-cell { background-color: #50A7DF; color: #fff; text-align: center; }
.custom-table .odd-row  { background: linear-gradient(to right, #fff 0%, #d9edff 100%); }
.custom-table .even-row { background: linear-gradient(to left,  #fff 0%, #d9edff 100%); }

.table-scroller {
  overflow: hidden;  /* 桌機預設不滾動 */
}

@media (max-width: 899px) {
  .table-scroller {
    overflow-x: auto;   /* 手機版啟用橫向滾動 */
    -webkit-overflow-scrolling: touch;
  }

  .table-scroller table {
    min-width: 700px;  /* 給一個最小寬度，確保會觸發滾動 */
  }
}


/* ---------------------------------------
 * 針長度選擇區（len-guide）
 * ------------------------------------- */
.len-guide{
  --content-pad:24px;
  position:relative;
  width:calc(100% + (var(--content-pad) * 2));
  margin-left:calc(var(--content-pad) * -1);
  margin-right:calc(var(--content-pad) * -1);
  background:#fff;
  aspect-ratio: 1920 / 550;
  display:flex; flex-direction:column;
  align-items:center; justify-content:center;
}
@media (max-width: 899px){
  .len-guide{ --content-pad:16px; aspect-ratio: 1080 / 1067; padding: 32px 0; }
}

.len-inner{
  width: 100%;
  max-width: 1100px;
  margin: 32px auto 40px;
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 24px; justify-items: center;
}
@media (max-width: 899px){
  .len-inner{ grid-template-columns: 1fr; padding: 16px 16px 16px; }
}

.len-card{ width: 100%; display: flex; flex-direction: column; align-items: center; text-align: center; gap: 10px; background: transparent; box-shadow: none; border-radius: 0; padding: 0; }

.len-chip{
  display: inline-flex; align-items: center; justify-content: center;
  width: 20vw; max-width: 320px; min-width: 180px; height: 48px;
  padding: 0; border-radius: 12px; color: #fff; font-weight: 700;
  background: linear-gradient(90deg, #469cd6, #d1dc62);
}
@media (max-width: 899px){ .len-chip{ width: 60vw; min-width: 0; } }

.len-h4{ margin: 5px 0 5px; font-weight: 800; color: #0b69b7; text-align: center; }

.len-list{ list-style: none; padding: 0; margin: 0; line-height: 1.6; color: #000; text-align: center; }

.len-link{ display:inline-block; margin-top:4px; font-size: 0.9rem; font-weight: 700; color:#0b69b7; text-decoration: none; }
.len-link:hover,.len-link:focus{ text-decoration: underline; }

/* ---------------------------------------
 * STERiJECT_05 區塊（s5-hero）
 * ------------------------------------- */
.s5-hero { position: relative; }
.s5-overlay{
  position:absolute; top:50%; left:50%; transform: translate(-50%, -50%);
  width:100%; max-width:1100px; height:auto;
}
.s5-badge{
  position:absolute; top:50%; left:50%;
  transform: translate(-110%, -50%);
  width: clamp(120px, 18vw, 220px); height:auto;
}
.s5-copy{
  position:absolute; top:50%; left:50%; transform: translate(10%, -50%);
  max-width: 420px; text-align:left; padding-right: 60px;
}
.s5-title{ margin:0 0 8px; font-weight:800; color:#306fb4; }
.s5-body { margin:0; color:#000; line-height:1.6; font-size:1rem; }

@media (max-width: 899px){
  .s5-hero{ height: 320px; position: relative; }
  .s5-hero .row-img{ height: 100%; width: auto; min-width: 120%; object-fit: cover; object-position: center; }
  .s5-badge{ transform: translate(-125%, -50%); width:100px; }
  .s5-copy{ transform: translate(5%, -50%); max-width: 55%; text-align:left; }
}

/* ---------------------------------------
 * 統一所有「大標」字級（與 len-title 一致）
 * ------------------------------------- */
.STERiJECT{
  --headline-size: clamp(20px, 2.8vw, 34px);
  --headline-line-height: 1.15;
  --headline-letter: .01em;
}
@supports (font-size: 1cqw){
  .STERiJECT{ --headline-size: clamp(20px, 4.6cqw, 34px); }
}

/* 套用到所有需要的大標（移除各處零散 font-size） */
.len-title,
.ov-title,
.inter-title,
.s2-title h3,
.second-image-row .ov-title,
.third-image-row .third-desktop-overlay .ov-title,
.third-image-row .third-mobile .inter-title {
  font-size: var(--headline-size) !important;
  line-height: var(--headline-line-height) !important;
  letter-spacing: var(--headline-letter) !important;
}

@media (max-width: 899px){
  .len-title, .ov-title, .inter-title, .s2-title h3,
  .second-image-row .ov-title,
  .third-image-row .third-desktop-overlay .ov-title,
  .third-image-row .third-mobile .inter-title {
    letter-spacing: .005em !important;
  }
}
</style>

